import Axios, { AxiosRequestConfig } from 'axios';

import { API_URL, APP_PATH } from '@/config';
import { useNotificationStore } from '@/stores/notifications';
import storage from '@/utils/storage';
import { showNotification } from '@/utils/notificationUtils';
import moment from 'moment-timezone';
import { useAuth } from './auth';
let apiCounter = 0;

async function authRequestInterceptor(config: AxiosRequestConfig) {
  const token = storage.getToken();

  if (token) {
    config.headers.authorization = `${token}`;
  }
  config.headers.Accept = 'application/json';
  config.headers['Cache-Control'] = 'no-cache';
  config.headers.Pragma = 'no-cache';
  config.headers.Expires = '0';
  config.headers['loc-id'] = config.headers['loc-id']
    ? config.headers['loc-id']
    : storage.getKey('activeLocationId');
  config.headers.tz = moment.tz.guess(true);
  config.params = { ...config.params, _: Date.now() };
  apiCounter++;
  //document.body.classList.add('loading-indicator');
  return config;
}

export const axios = Axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

axios.interceptors.request.use(authRequestInterceptor, (error) => {
  apiCounter++;
  return Promise.reject(error);
});
axios.interceptors.response.use(
  (response) => {
    if (response?.status === 401) {
      showNotification({
        type: 'error',
        title:
          'Unautorized Access, You have been logged out of the application. Please login again to continue',
      });
      setTimeout(() => {
        storage.clearToken();
        storage.clearSAToken();
        window.location.assign((window.location.origin + APP_PATH) as unknown as string);
      }, 2000);
      return;
    }
    if (
      (response.headers['content-type'] === 'text/csv' ||
        response.headers['content-type'] ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
      response.status == 200
    ) {
      return response.data;
    }
    if (response?.data?.result?.status) {
      if (apiCounter > 0) {
        apiCounter--;
      }
      if (apiCounter <= 0) {
        document.body.classList.remove('loading-indicator');
      }
      if (response?.data?.result?.status && response?.data?.result?.code) {
        showNotification({
          type: 'info',
          title: response?.data?.result?.message,
        });
      }
      return response.data.responseData;
    } else {
      if (response?.data?.errors?.[0]?.code === 'ERR169') {
        storage.clearToken();
        storage.clearSAToken();
        window.location.assign((window.location.origin + APP_PATH) as unknown as string);
      }
      const message = response?.data?.errors?.[0]?.message;
      showNotification({
        type: 'error',
        title: message,
      });
      return Promise.reject(response?.data);
    }
  },
  (error) => {
    if (error?.response?.status === 401) {
      if (error?.response?.config?.url === '/business/email/login') {
        showNotification({
          type: 'error',
          title: 'Incorrect Email or Password.',
        });
      } else {
        showNotification({
          type: 'error',
          title:
            'Unautorized Access, You have been logged out of the application. Please login again to continue',
        });
        setTimeout(() => {
          storage.clearToken();
          storage.clearSAToken();
          window.location.assign((window.location.origin + APP_PATH) as unknown as string);
        }, 2000);
      }

      return;
    }
    if (apiCounter > 0) {
      apiCounter--;
    }
    if (apiCounter <= 0) {
      document.body.classList.remove('loading-indicator');
    }

    const arr = ['ERR020', 'ERR202', 'ERR161'];
    let canIgnore = false;
    if (
      (error && error.response && error.response.data && error.response.data.message) ||
      (error && error.message)
    ) {
      let message = error.response?.data?.message || error.message;
      if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
        message = `${error.response?.data?.errors[0]?.message}`;
        if (arr.includes(error.response?.data?.errors[0]?.code)) {
          canIgnore = true;
        }
        if (message.includes('field is required') > 0) {
          message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
        }
      }
      if (!canIgnore) {
        showNotification({
          type: 'error',
          title: message,
        });
        if (error.response?.data?.errors[0]?.code === 'ERR169') {
          setTimeout(() => {
            storage.clearToken();
            storage.clearSAToken();
            window.location.assign((window.location.origin + APP_PATH) as unknown as string);
          }, 2000);
        }
      }
    }

    return Promise.reject(error);
  }
);
